import { setHitMax } from '../../shared/helpers/maximums'
import { isChildLearning } from '../../shared/helpers/logic'
// - for each dependency we do setHitMax
// - this will return an object with true and false values
// - the goal is to switch as many of the object values to false as possible
// - so we go through each dependency, set the hit max and store the resulting hitMaxObject
// - go through the next dependency and set any values that were true to false if the dependency opens up that option

export const setHitMaximumsWithDependencies = (
  dependent,
  dependencies,
  membership,
  employeeMax,
  membershipMax,
  hitSpecificConstituencyMax
) => {
  let { tickets, availability, cartTotal, quantityLimit } = dependent
  if (cartTotal) availability += cartTotal
  if (quantityLimit && quantityLimit < availability) {
    availability = quantityLimit
  }

  let hitMax = {
    member: {
      nonResident: {}
    },
    nonMember: {
      resident: {},
      nonResident: {}
    }
  }
  if (dependencies.length === 0) {
    hitMax = setHitMax(
      null,
      tickets,
      membership,
      availability,
      isChildLearning(dependent.pricing.member),
      employeeMax,
      membershipMax,
      hitSpecificConstituencyMax
    )
  } else {
    dependencies.forEach(dependency => {
      const hitMaximumsForDependency = setHitMax(
        tickets,
        dependency.tickets,
        membership,
        availability,
        isChildLearning(dependency.pricing.member),
        employeeMax,
        membershipMax
      )

      // The code below might not be needed anymore. Return setHitMax instead of remaking it from hitMaximumsForDependency
      Object.keys(hitMaximumsForDependency).forEach(memberKey => {
        Object.keys(hitMaximumsForDependency[memberKey]).forEach(
          residentKey => {
            Object.entries(
              hitMaximumsForDependency[memberKey][residentKey]
            ).forEach(([ageKey, hitDependencyMaximum]) => {
              if (
                hitMax[memberKey][residentKey][ageKey] == null ||
                (hitMax[memberKey][residentKey][ageKey] &&
                  !hitDependencyMaximum)
              ) {
                hitMax[memberKey][residentKey][ageKey] = hitDependencyMaximum
              }
            })
          }
        )
      })
    })
  }
  return hitMax
}
